import { useState } from 'react'
import { Link } from 'react-router-dom'
import { IHeaderMenu } from './header-user'

export default function MenuHeaderMobile({ menu }: { menu: IHeaderMenu }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => setIsOpen(!isOpen)

  return (
    <div className="lg:hidden flex relative h-8 w-8">
      <button
        onClick={handleClick}
        className="absolute top-1/2 right-0 flex flex-col justify-around w-8 h-8 bg-transparent border-none cursor-pointer p-0 z-10 focus:outline-none -translate-y-1/2"
        aria-expanded={isOpen}
        aria-label="Toggle menu"
      >
        <div
          className={`w-8 h-1 rounded-[10px] transition-all duration-300 ease-linear origin-[1px] bg-[#2c2c2c] ${
            isOpen ? 'translate-y-[21px] -rotate-45 bg-gray-500' : ''
          }`}
        />
        <div
          className={`w-8 h-1 rounded-[10px] transition-all duration-300 ease-linear origin-[1px] bg-[#2c2c2c] ${
            isOpen ? 'opacity-0 -translate-x-5' : ''
          }`}
        />
        <div
          className={`w-8 h-1 rounded-[10px] transition-all duration-300 ease-linear origin-[1px] bg-[#2c2c2c] ${
            isOpen ? '-translate-y-[21px] rotate-45 bg-gray-500' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="flex flex-col justify-center bg-white h-screen w-screen text-left p-8 fixed top-0 right-0 transition-transform duration-300 ease-in-out">
          <nav className="flex flex-col justify-center h-full">
            <div className="">
              {menu.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="block text-[32px] uppercase py-8 px-0 font-bold tracking-[0.5rem] transition-colors duration-300 ease-linear"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </nav>
        </div>
      )}
    </div>
  )
}
